import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import Header from './Header';
import { PAGE_TO_PATH, PATH_TO_PAGE } from './seoConfig';
import LoadingSpinner from '../common/LoadingSpinner';

const Website = () => {
  const { user } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const currentPage = location.pathname.startsWith('/scrapers/')
    ? 'web-scraping'
    : PATH_TO_PAGE[location.pathname] || 'home';


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleNavigation = (page) => {
    const path = PAGE_TO_PATH[page] || '/';
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header currentPage={currentPage} onNavigate={handleNavigation} user={user} />
      <main id="main-content">
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet context={{ onNavigate: handleNavigation }} />
        </Suspense>
      </main>
    </div>
  );
};

export default Website;
